import { Slice } from '@reduxjs/toolkit';
import { useCallback } from 'react';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { roomSceneSlice } from './roomScene.slice';
import { store } from './store';
import { tileSlice } from './tile.slice';
import { userSlice } from './user.slice';

type AppDispatch = typeof store.dispatch;
type RootState = ReturnType<typeof store.getState>;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

const sliceList = [tileSlice, userSlice, roomSceneSlice];

export const useInitStore = () => {
  const dispatch = useAppDispatch();

  const populateDataFromCache = useCallback(() => {
    const dispatchSliceActions = (slice: Slice) => {
      const sliceActions = Object.values(slice.actions);
      sliceActions.forEach((action) => {
        const cachedValue = localStorage.getItem(action.type);
        if (cachedValue) {
          dispatch({ type: action.type, payload: JSON.parse(cachedValue) });
        }
      });
    };
    sliceList.forEach((slice) => dispatchSliceActions(slice));
  }, [dispatch]);

  return {
    populateDataFromCache,
  };
};
